module.exports = __webpack_public_path__ + "img/schmoozer.4c6bddba.png";